<template>
  <div class="stock">
      <div class="search">
          <el-input v-model="deviceid" placeholder="设备ID"></el-input>
          <el-input v-model="devicename" placeholder="设备名称"></el-input>
          <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
      </div>
      <div class="tablelist">
          <el-table
            :data="tableData"
            :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
            style="width: 100%">
            <el-table-column
                prop="id"
                label="设备ID"
                width="120">
            </el-table-column>                             
            <el-table-column
                prop="deviceName"
                label="设备名称"
                width="130">
            </el-table-column>
            <el-table-column
                prop="usableCount"
                width="150"
                label="现有数量">
            </el-table-column>
            <el-table-column
                prop="returnCount"
                width="150"
                label="退货中数量">
            </el-table-column>
            <el-table-column
                width="200"
                prop="sellCount"
                label="销售数量">
            </el-table-column>
            <el-table-column
                prop=""
                label="操作">
                <template slot-scope="scope">
                    <el-link :underline="false" @click="detail(scope.row)">明细</el-link>
                </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="page">
          <el-pagination
            :background="true"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
      </div>
  </div>
</template>

<script>
import {queryCount,stocksearch} from '../axios/api'
export default {
    data(){
        return{
            deviceid:'',
            devicename:'',
            tableData:[],
            total:0,
            page:1,
            currentPage4:1,
            flag:true,
            states:0
        }
    },
    created(){
        this.getdata()
    },
    methods:{

        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.page = val
            if(this.states == 0){
                this.getdata()
            }else{
                this.search1()
            }
        },
        async getdata(){
            this.states = 0
            var {data:dt} = await queryCount({
                current:this.page,
                limit:10,
                shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.total = dt.data.total
                this.tableData = dt.data.records
            }
        },
        async search(){
            this.states = 1
            var {data:dt} = await stocksearch({
                current:1,
                limit:10,
                shopId:window.localStorage.getItem('shopId'),
                id:this.deviceid,
                deviceName:this.devicename
            })
            console.log(dt)
            if(dt.code == 200){
                this.page = 1
                this.tableData = dt.data.records
                this.total = dt.data.total
            }
        },
        async search1(){
            this.states = 1
            var {data:dt} = await stocksearch({
                current:this.page,
                limit:10,
                shopId:window.localStorage.getItem('shopId'),
                id:this.deviceid,
                deviceName:this.devicename
            })
            console.log(dt)
            if(dt.code == 200){
                this.tableData = dt.data.records
                this.total = dt.data.total
            }
        },
        detail(row){
            console.log(row)
            this.$router.push({
                name:'库存明细',
                params:{
                    id:row.id
                }
            })
        }
    }
}

</script>
<style lang="less" scoped>
.stock{
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .tablelist{
        margin-top: 15px;
        .el-link.el-link--default {
            color: #409eff;
            margin-right: 12px;
        }
    }
}
</style>